// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box, Anchor } from 'grommet'
import PropTypes from 'prop-types'

import { Typography } from '../../../../components'

const ActionResults = ({
  data,
  historyObject,
  setOpenDropdown,
  i18nTranslation,
  handleActionClick
}) => (
  <Box
    pad={{ bottom: 'medium', top: 'small' }}
    border={{
      side: 'bottom',
      color: 'border-weak',
      size: 'small'
    }}
  >
    <Typography
      type="text"
      testId="next-steps-title"
      color="text-weak"
      size="xsmall"
      margin={{ vertical: 'small' }}
    >
      {i18nTranslation('global_search.next_steps')}
    </Typography>
    {data && (
      <Box gap="small">
        <Typography type="heading" level="3" testId="action-title">
          <Anchor
            onClick={() => {
              historyObject.push(data.actionUrl)
              setOpenDropdown(false)
              handleActionClick(data.actionTitle)
            }}
            label={data.actionTitle}
            data-testid="next-steps-action"
          />
        </Typography>
        <Typography
          type="paragraph"
          maxLines={2}
          fill
          testId="action-description"
        >
          {data.actionDescription}
        </Typography>
      </Box>
    )}
  </Box>
)

ActionResults.propTypes = {
  data: PropTypes.object.isRequired,
  historyObject: PropTypes.object.isRequired,
  setOpenDropdown: PropTypes.func.isRequired,
  i18nTranslation: PropTypes.any.isRequired,
  handleActionClick: PropTypes.func.isRequired
}

export { ActionResults }
